export default __webpack_public_path__ + "static/media/Settings_Language.1957da3c.svg";